module.exports = __webpack_public_path__ + "static/logo-bank-mandiri-7c020a981eedf02c821944b284e4ce3d.png";